const handleClick = (event) => {
  const target = event.target;
  if (target.tagName === "A") {
    const isExternal = target.hostname !== window.location.hostname;
    const isPdf = target.href.toLowerCase().endsWith(".pdf");

    if (isExternal || isPdf) {
      target.setAttribute("target", "_blank");
      target.setAttribute("rel", "noopener noreferrer");
    }
  }
};

export const onRouteUpdate = () => {
  document.addEventListener("click", handleClick);
};

export const onPreRouteUpdate = () => {
  document.removeEventListener("click", handleClick);
};
